import React from 'react';
import { JobStatut } from '../types';

interface Props {
  job: JobStatut;
}

export function JobProgressBar({ job }: Props) {
  const prog = job.progression;
  const pct = prog && prog.total > 0 ? Math.round((prog.traites / prog.total) * 100) : 0;
  const isTermine = job.statut === 'completed' || job.statut === 'failed';

  return (
    <div className="space-y-3">
      <div className="flex justify-between text-sm text-content-muted">
        <span>
          {prog ? `${prog.traites} / ${prog.total} employés traités` : 'En attente...'}
        </span>
        <span className={isTermine ? (job.statut === 'completed' ? 'text-success font-medium' : 'text-danger') : 'text-accent'}>
          {job.statut === 'waiting' && 'En attente'}
          {job.statut === 'active' && 'En cours...'}
          {job.statut === 'completed' && 'Terminé'}
          {job.statut === 'failed' && 'Échec'}
        </span>
      </div>
      <div className="w-full bg-surface-overlay rounded-full h-3">
        <div
          className={`h-3 rounded-full transition-all duration-500 ${
            job.statut === 'failed' ? 'bg-danger' : job.statut === 'completed' ? 'bg-success' : 'bg-accent'
          }`}
          style={{ width: `${isTermine ? 100 : pct}%` }}
        />
      </div>
      {prog && prog.erreurs > 0 && (
        <p className="text-sm text-danger">{prog.erreurs} erreur(s)</p>
      )}
      {job.resultat?.erreurs && job.resultat.erreurs.length > 0 && (
        <ul className="text-xs text-danger mt-2 space-y-1">
          {job.resultat.erreurs.map((e, i) => (
            <li key={i}>❌ {e.idEmploye} — {e.message}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
